import Slider from 'bootstrap-slider';

export function initPriceSlider(selector) {
    const sliders = document.querySelectorAll(selector);
    if (!sliders.length) return;

    sliders.forEach(sliderEl => {
        // Skip if already initialized
        if (sliderEl.getAttribute('data-slider-initialized') === 'true') return;
        
        const prefix = sliderEl.dataset.sliderPrefix || '';
        new Slider(sliderEl, {
            formatter: function(value) {
                if (Array.isArray(value)) {
                    return `${prefix}${value[0]} - ${prefix}${value[1]}`;
                }
                return `${prefix}${value}`;
            }
        });
        
        // Mark as initialized
        sliderEl.setAttribute('data-slider-initialized', 'true');
    });
}
                